<div class="columns">
  <tui-input-files
    class="column control"
    [formControl]="control.control"
    [maxFileSize]="maxFileSize"
    [multiple]="false"
    [accept]="accept"
  >
    <ng-template>
      <div class="content wo-file-uploader-content">
        <iss-icon name="upload"/>
        <div class="wo-file-uploader-content-text">
          <div class="wo-file-uploader-content-text-title"><ng-content/></div>
          <div class="wo-file-uploader-content-text-info">Max. file size: 5 mb / xlsx, xls</div>
        </div>
      </div>
    </ng-template>
  </tui-input-files>
</div>

<div class="columns" *ngIf="file">
  <tui-files class="column">
    <tui-file
      [file]="file"
      [leftContent]="content"
    />
  </tui-files>
</div>

<ng-template #content>
  <tui-svg src="tuiIconClockLarge"></tui-svg>
</ng-template>
